import React from 'react'
import { IDatesPickerProps } from './dates-picker-props.interface'
import { addDays } from 'date-fns'
import { DatePicker } from 'components'
import './dates-picker.scss'

const DatesPicker: React.FC<IDatesPickerProps> = ({ dateFrom, dateTo, changeFrom, changeTo, extraClassName = '' }) => {
  const now = new Date()

  return (
    <div className={'edisu-dates-picker ' + extraClassName}>
      <DatePicker onChange={changeFrom} value={dateFrom} minDate={addDays(now, 1)} />

      <DatePicker onChange={changeTo} value={dateTo} minDate={dateFrom && addDays(dateFrom, 1)} />
    </div>
  )
}

export default DatesPicker
